import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAnalytics } from '../contexts/AnalyticsContext';
import { getVisitorId } from '../services/visitorId';

export function IdentityLinker() {
  const { user } = useAuth();
  const { track } = useAnalytics();
  const linkedRef = useRef(false);

  useEffect(() => {
    if (!user?.id || linkedRef.current) return;

    const vid = getVisitorId();
    if (!vid) return;

    const linkKey = `sparkapp_identity_linked_${vid}`;
    if (localStorage.getItem(linkKey)) {
      linkedRef.current = true;
      return;
    }

    track('identity_link', { visitor_id: vid, user_id: String(user.id) });
    localStorage.setItem(linkKey, 'true');
    linkedRef.current = true;
  }, [user?.id, track]);

  return null;
}
